// GTM dataLayer olay yardımcıları.
//
// Bu fonksiyonlar olayları yalnızca `window.dataLayer` dizisine push eder.
// GA4 ve Google Ads etiketleri Google Tag Manager panelinden bu olaylara
// (event adlarına) tetikleyici olarak bağlanır — koda etiket gömülmez.
//
// GTM'de oluşturulması gereken özel olaylar (Custom Event trigger):
//   - generate_lead   → İletişim formu başarıyla gönderildi (ana dönüşüm)
//   - whatsapp_click  → WhatsApp butonuna tıklandı
//   - phone_click     → Telefon numarasına tıklandı
//   - email_click     → E-posta adresine tıklandı
//   - cta_click       → Bir CTA butonuna tıklandı (Bize Ulaşın, Kataloğu İndir vb.)

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

type EventParams = Record<string, unknown>;

/** Genel amaçlı dataLayer push. Diğer yardımcılar bunu kullanır. */
export function pushEvent(event: string, params: EventParams = {}): void {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

/** İletişim formu başarıyla gönderildi — ana dönüşüm (lead). */
export function trackLeadSubmit(params: EventParams = {}): void {
  pushEvent('generate_lead', { form_name: 'contact', ...params });
}

/** WhatsApp butonuna tıklandı. `location` = butonun yeri (ör. 'fab'). */
export function trackWhatsAppClick(location: string): void {
  pushEvent('whatsapp_click', { link_location: location });
}

/** Telefon numarasına tıklandı. */
export function trackPhoneClick(phoneNumber: string, location: string): void {
  pushEvent('phone_click', { phone_number: phoneNumber, link_location: location });
}

/** E-posta adresine tıklandı. */
export function trackEmailClick(email: string, location: string): void {
  pushEvent('email_click', { email_address: email, link_location: location });
}

/** Bir CTA butonuna tıklandı. `label` = buton metni, `location` = bulunduğu bölüm. */
export function trackCtaClick(label: string, location: string): void {
  pushEvent('cta_click', { cta_label: label, link_location: location });
}
